import React from "react";
import { ReactComponent as EmptyDataIcon } from '../../assets/svg/empty-data-icon.svg';

const FxNoGridDataImage: React.FC = () => {
  return (
    <EmptyDataIcon className="fx-empty-data-icon"/>
  )
}
export default FxNoGridDataImage;